import { DateTime } from 'luxon'
import { utcToZonedTime } from '@toasttab/buffet-pui-date-utilities'

export const getRxDateFromISO = (
  isoStr?: string | Date,
  timezoneId?: string
) => {
  if (!isoStr) return undefined
  if (typeof isoStr === 'object') return utcToZonedTime(isoStr, timezoneId!!)
  return utcToZonedTime(isoStr, timezoneId!!)
}

export const isSameISODay = (first?: string, second?: string) => {
  if (!first || !second) {
    return false
  }
  const firstDate = DateTime.fromISO(first)
  const secondDate = DateTime.fromISO(second)
  return firstDate.hasSame(secondDate, 'day')
}

export const isSameISOTime = (first?: string, second?: string) => {
  if (!first || !second) {
    return false
  }
  const firstTime = DateTime.fromISO(first)
  const secondTime = DateTime.fromISO(second)
  return (
    firstTime.hour === secondTime.hour && firstTime.minute === secondTime.minute
  )
}

export const isISODateTimeEqual = (a: string, b: string) =>
  a === b || +DateTime.fromISO(a) === +DateTime.fromISO(b)
